/**
 * Filtrage par période active (trimestre…). Centralise le prédicat
 * « cette date est-elle dans la période ? » jusque-là copié ~12× dans
 * les utils de scoring et plusieurs pages.
 *
 * Règles (comportement historique dominant préservé) :
 *  - période incomplète (pas de bornes)  → true (on ne filtre pas) ;
 *  - date absente / invalide              → true (résultat conservé) ;
 *  - sinon                                → bornes INCLUSIVES date_debut..date_fin.
 *
 * @param {string|Date} dateLike     date du résultat (souvent `evalDate`)
 * @param {{date_debut?, date_fin?}} activePeriode  période active (ClasseContext)
 * @returns {boolean}
 */
export const isInPeriode = (dateLike, activePeriode) => {
  if (!activePeriode?.date_debut || !activePeriode?.date_fin) return true;
  if (!dateLike) return true; // null / undefined / '' → conservé
  const d = new Date(dateLike);
  if (isNaN(d.getTime())) return true; // date invalide → conservé
  return d >= new Date(activePeriode.date_debut) && d <= new Date(activePeriode.date_fin);
};

/**
 * La période scolaire qui CONTIENT la date (bornes inclusives), ou null :
 * date absente ou invalide, ou hors de toutes les périodes. Contrairement à
 * isInPeriode, une période sans bornes ne contient rien (on cherche la bonne,
 * on ne filtre pas). Sert à afficher « Période du suivi : Trimestre 1 »
 * sous la date de Coller mes notes (2026-09-29) : la date range les notes
 * dans un trimestre, le prof doit le voir.
 */
export const periodeDeLaDate = (dateLike, periodes) => {
  if (!dateLike) return null;
  const d = new Date(dateLike);
  if (isNaN(d.getTime())) return null;
  return (periodes || []).find((p) => p?.date_debut && p?.date_fin
    && d >= new Date(p.date_debut) && d <= new Date(p.date_fin)) || null;
};

/** « Trimestre 1 » pour une période { type_periode, numero }. */
export const libellePeriode = (p) => {
  const type = String(p?.type_periode || '');
  return `${type.charAt(0).toUpperCase()}${type.slice(1)} ${p?.numero ?? ''}`.trim();
};
